import { kebabCase, uniqueId } from 'lodash';

const getIdFromField = (field) => uniqueId(`${kebabCase(field.label)}`);

const mountFieldWithId = (fields) => {
  const map = {};
  const order = [];

  fields.forEach((field) => {
    const id = getIdFromField(field);
    map[id] = { ...field, id };
    order.push(id);
  });

  return { map, order };
};

export default {
  SET_FIELDS(state, payload) {
    const form1 = mountFieldWithId(payload.formFields1);
    const form2 = mountFieldWithId(payload.formFields2);

    state.formFields1 = form1.map;
    state.formFields1Order = form1.order;

    state.formFields2 = form2.map;
    state.formFields2Order = form2.order;
  },

  UPDATE_FIELD(state, { value, id, form }) {
    const formFields = state[`formFields${form}`];
    if (formFields[id]) {
      Object.assign(formFields[id], value);
    }
  },

  DELETE_FIELD(state, { id, form }) {
    const formFields = state[`formFields${form}`];
    const formOrder = state[`formFields${form}Order`];

    if (formFields[id]) {
      delete formFields[id];
      state[`formFields${form}`] = {
        ...formFields,
      };
      state[`formFields${form}Order`] = formOrder.filter((itemId) => itemId !== id);
    }
  },

  ADD_FIELD(state, { form, value }) {
    const id = getIdFromField(value);
    state[`formFields${form}`] = {
      ...state[`formFields${form}`],
      [id]: { ...value, id },
    };
    state[`formFields${form}Order`].push(id);
  },

  ADD_FIELD_FROM_ID(state, { form, value, afterId }) {
    const id = getIdFromField(value);
    state[`formFields${form}`][id] = { ...value, id };

    const order = state[`formFields${form}Order`];
    const index = order.indexOf(afterId);

    if (index !== -1) {
      order.splice(index + 1, 0, id);
    } else {
      order.push(id);
    }
  },

  REORDER_FIELDS(state, { form, fields }) {
    const formFields = state[`formFields${form}`];
    const validOrder = fields.filter((id) => formFields[id]);

    state[`formFields${form}Order`] = validOrder;
  },

  SET_PREVENT_COPY(state, value) {
    state.preventCopy = value;
  },

  SET_SELECTED_FIELD_INDEX(state, { id, form }) {
    state.selectedFieldIndex = {
      id,
      form,
    };
  },

  DELETE_CEP_FIELD(state, { id, form }) {
    const formFields = state[`formFields${form}`];
    const order = state[`formFields${form}Order`];
    const selectedField = formFields[id];

    const updated = Object.entries(formFields)
      .filter(([fieldId, field]) => {
        const isSelected = fieldId === id;
        const isLinked =
          selectedField.name &&
          (field.linkedWithField ?? field.linked_with_field) === selectedField.name;

        return !isSelected && !isLinked;
      })
      .reduce((acc, [fieldId, field]) => {
        acc[fieldId] = field;
        return acc;
      }, {});

    const updatedOrder = order.filter((fieldId) =>
      Object.prototype.hasOwnProperty.call(updated, fieldId)
    );

    state[`formFields${form}`] = updated;
    state[`formFields${form}Order`] = updatedOrder;
  },
};
